module.exports = __webpack_public_path__ + "img/10数据产品.09a388a9.png";